import { Bell } from "common/Icons/Icons";
import { useContext, useRef, useState } from "react";
import NotificationsModal from "features/notifications/NotificationModal";
import { useIsOnboarding } from "utils/hooks/misc";
import { skipToken } from "@reduxjs/toolkit/query";
import { AvoContext } from "analytics/AvoProvider";
import { IconProps } from "common/Icons/Icon";
import useSocketNotifications from "@shared/services/socket/useSocketNotifications";
import useNotificationsList from "@shared/features/notifications/useNotificationsList";
import HeaderIconWithBadge from "common/Home/Header/HeaderIconWithBadge";
import { useTheme } from "styled-components";
import { sharedLib } from "@shared/services/shared.service";

interface NotificationsButtonProps {
  iconSize: IconProps["$size"];
}

const NotificationsButton = ({ iconSize }: NotificationsButtonProps) => {
  const appTheme = useTheme();
  const { avo } = useContext(AvoContext);
  const isOnboarding = useIsOnboarding();
  const [notificationsModalOpen, setNotificationsModalOpen] = useState(false);
  const notificationsOpenTime = useRef<number | undefined>();
  useSocketNotifications();

  const { data: notifications } =
    sharedLib.sharedApi.notifications.useGetNotificationsQuery(
      isOnboarding ? skipToken : undefined
    );
  const {
    numUnreadNotifications,
    showNotificationsCounter,
    notificationCounterText,
    oneDigitCounter,
  } = useNotificationsList(notifications);

  const button = (
    <HeaderIconWithBadge
      icon={
        <Bell
          $size={iconSize}
          style={{ marginRight: 8 }}
          onClick={() => setNotificationsModalOpen(!notificationsModalOpen)}
        />
      }
      counterColor={appTheme.colors.red}
      counterText={notificationCounterText}
      showCounter={showNotificationsCounter}
      oneDigit={oneDigitCounter}
      isActive={notificationsModalOpen}
    />
  );

  const onOpenModal = () => {
    setNotificationsModalOpen(true);
    avo?.showNotificationsClicked();
    notificationsOpenTime.current = new Date().getTime();
  };

  const onCloseModal = () => {
    setNotificationsModalOpen(false);
    if (notificationsOpenTime.current) {
      avo?.closeNotificationsClicked({
        notificationsReviewTime:
          new Date().getTime() - notificationsOpenTime.current,
      });
      notificationsOpenTime.current = undefined;
    }
  };

  return (
    <NotificationsModal
      visible={notificationsModalOpen}
      onCloseModal={onCloseModal}
      onOpenModal={onOpenModal}
      trigger={button}
      numUnreadNotifications={numUnreadNotifications}
    />
  );
};

export default NotificationsButton;
